// Environment configuration
export const config = {
    NEXT_PUBLIC_AI_DASHBOARD_API_URL: process.env.NEXT_PUBLIC_AI_DASHBOARD_API_URL || "",
    WIDGET_API_ENDPOINT: process.env.NEXT_PUBLIC_AI_DASHBOARD_API_URL + "/agent",
    DASHBOARD_API_ENDPOINT: process.env.NEXT_PUBLIC_AI_DASHBOARD_API_URL + "/dashboards",
    WIDGET_DATA_API_ENDPOINT: process.env.NEXT_PUBLIC_AI_DASHBOARD_API_URL + "/get-widget-data",
    WIDGET_DATA_API_EXPORT_ENDPOINT: process.env.NEXT_PUBLIC_AI_DASHBOARD_API_URL + "/get-widget-data-export",
    CLIENT_ID: process.env.NEXT_PUBLIC_CLIENT_ID || "776",
    AGENT_ID: process.env.NEXT_PUBLIC_AGENT_ID || "",
    AGENT_ALIAS_ID: process.env.NEXT_PUBLIC_AGENT_ALIAS_ID || "",
    DASHBOARD_ID: process.env.NEXT_PUBLIC_DASHBOARD_ID || 1,
    SHOW_NON_UAT_APPS: process.env.NEXT_PUBLIC_SHOW_NON_UAT_APPS === "true",
    /** GA4 Measurement ID (e.g. "G-XXXXXXXXXX"). Leave empty to disable analytics. */
    GA_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || "",
    INCENTIVES_MANAGER_URL: process.env.NEXT_PUBLIC_INCENTIVES_MANAGER_URL || "",
    LAUNCH_FORM_URL: process.env.NEXT_PUBLIC_LAUNCH_FORM_URL || "",
    VDP_CONNECT_URL: process.env.NEXT_PUBLIC_VDP_CONNECT_URL || "",
    MICROSOFT_SSO_CLIENT_ID: process.env.NEXT_PUBLIC_MICROSOFT_SSO_CLIENT_ID || "8c15bf99-d88a-4f85-98fa-6bca79e8694b",
    MICROSOFT_SSO_TENANT_ID: process.env.NEXT_PUBLIC_MICROSOFT_SSO_TENANT_ID || "06061284-b266-48e0-8b41-ff3c1b88258b",

    //Feature Flags
    PAGE_INSIGHTS_ENABLED: process.env.NEXT_PUBLIC_PAGE_INSIGHTS_ENABLED === "true",
    POPUP_PHONE_NUMBER_ACTIVE: process.env.NEXT_PUBLIC_POPUP_PHONE_NUMBER_ACTIVE !== "false",
    SHOW_CONTRACT_DETAILS: process.env.NEXT_PUBLIC_SHOW_CONTRACT_DETAILS === "true",
    SHOW_SSO: process.env.NEXT_PUBLIC_SHOW_SSO === "true",
    AGENT_V2_ENABLED: process.env.NEXT_PUBLIC_AGENT_V2_ENABLED === "true",
    AGENT_POC_ENABLED: process.env.NEXT_PUBLIC_AGENT_POC_ENABLED === "true",
    // Feature flag: show a preview of the AI edit before saving.
    // Set NEXT_PUBLIC_EDIT_WIDGET_PREVIEW_ENABLED=true to enable.
    // Must be paired with EDIT_WIDGET_PREVIEW_ENABLED=true on the backend.
    EDIT_WIDGET_PREVIEW_ENABLED: process.env.NEXT_PUBLIC_EDIT_WIDGET_PREVIEW_ENABLED === "true",
    WIDGET_INSIGHTS_V2_ENABLED: process.env.NEXT_PUBLIC_WIDGET_INSIGHTS_V2_ENABLED === "true",
    PAGE_BUILDOUT_EXCLUDED_PRODUCTS: (process.env.NEXT_PUBLIC_PAGE_BUILDOUT_EXCLUDED_PRODUCTS ?? "SEO,Chrysler Fiat SEO")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean),
    WIDGET_INSIGHT_EVENT_TRIGGER: (process.env.NEXT_PUBLIC_WIDGET_INSIGHT_EVENT_TRIGGER ?? "widget-insights-v2") as "widget-insights" | "widget-insights-v2" | "widget-insights-v3",
    WIDGET_RECOMMENDATION_EVENT_TRIGGER: (process.env.NEXT_PUBLIC_WIDGET_RECOMMENDATION_EVENT_TRIGGER ?? "widget-recommendations-v3") as "widget-recommendations-v3",
} as const;
